import { Component, OnInit, Inject } from '@angular/core';
import { ConfirmBoxModel } from './confirm-box.model';
import { NotificationManager } from '../../notification-manager';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-confirm-box',
    templateUrl: './confirm-box.component.html',
    styleUrls: ['./confirm-box.component.scss']
})
export class ConfirmBoxDialog implements OnInit {
    model: ConfirmBoxModel;
    public REASON_MAX_SIZE = 100;
    ValidReasonMaxLength = new UntypedFormControl('', [Validators.maxLength(this.REASON_MAX_SIZE)]);

    constructor(
        public dialogRef: MatDialogRef<ConfirmBoxDialog>,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmBoxModel) {
        this.model = Object.assign({}, data);
    }

    ngOnInit() {
        if (this.data.WithLengthValidation) {
            this.ValidReasonMaxLength.markAsTouched();
        }
    }

    canSave() {
        if (this.model.WithReason) {
            if (!this.model.Reason) {
                return false;
            }
        }
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (!this.canSave()) {
            NotificationManager.handleWarning('Veuillez entrer une raison.', this.snackBar);
            return;
        }
        this.dialogRef.close(this.model);
    }
}
